// extracted by mini-css-extract-plugin
export var container = "CardsContainer-module--container--2YhBo";
export var wrapper = "CardsContainer-module--wrapper--1uUjR";
export var cardElement = "CardsContainer-module--cardElement--3JH1v";
export var pagination = "CardsContainer-module--pagination--11AC8";